var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F5F5F7"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.947 11.947v16.106h14.568V16.02l-3.895-4.074H12.947zm-.947 0c0-.503.395-.947.927-.947h11.098l4.437 4.64v12.413c0 .503-.395.947-.926.947h-14.61c-.53 0-.926-.444-.926-.947V11.947z",
  fill: "#7D7D7D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m24.001 11.66 4.166 4.358h-3.713a.464.464 0 0 1-.453-.474V11.66z",
  fill: "#7D7D7D"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.825 11.22a.474.474 0 0 1 .519.113l4.166 4.357a.474.474 0 0 1-.343.801h-3.713c-.531 0-.926-.444-.926-.947V11.66c0-.194.117-.368.297-.44zm.65 1.621v2.703h2.584l-2.584-2.703z",
  fill: "#7D7D7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceIcon);
export default ForwardRef;